import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, LogIn } from 'lucide-react';
import { useHesapBranding } from '../../store/hesapBrandingStore';
import { BrandLogo } from '../../components/hesap/BrandLogo';
import { AdSlider, AdCards } from '../../components/hesap/landing/AdBlocks';
import { ModulesGrid } from '../../components/hesap/landing/ModulesGrid';
import { ContactSection, WhatsAppFab } from '../../components/hesap/landing/ContactSection';

export default function HesapLandingPage() {
  const { title, settings, load } = useHesapBranding();
  useEffect(() => { if (!settings) load(); }, [settings, load]);

  const s = settings || {};
  const landing = s.landing || {};
  const contact = s.contact || {};
  const ads = (s.ads || []).filter(a => a.active !== false);
  const byPlace = (p) => ads.filter(a => a.placement === p);

  return (
    <div className="min-h-screen bg-slate-950 text-white" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="hesap-landing-page">
      <style>{'@keyframes fadeInUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}'}</style>
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-slate-950/70 border-b border-white/5">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <BrandLogo testId="landing-brand-logo" />
            <span className="font-bold truncate" data-testid="landing-brand-title">{title}</span>
          </div>
          <nav className="flex items-center gap-2">
            <a href="#moduller" className="hidden md:inline text-sm text-slate-300 hover:text-white px-3">Modüller</a>
            {(contact.phone || contact.email || contact.whatsapp || contact.address) && <a href="#iletisim" className="hidden md:inline text-sm text-slate-300 hover:text-white px-3">İletişim</a>}
            <Link to="/giris" className="text-sm font-medium px-4 py-2 rounded-full border border-white/15 hover:bg-white/5 transition-colors" data-testid="landing-login-btn">Giriş Yap</Link>
            <Link to="/kayit" className="hidden sm:inline text-sm font-semibold px-4 py-2 rounded-full bg-emerald-500 hover:bg-emerald-600 transition-colors" data-testid="landing-register-btn">Kayıt Ol</Link>
          </nav>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[28rem] h-[28rem] bg-emerald-500/25 rounded-full blur-3xl" />
        <div className="absolute top-20 right-0 w-96 h-96 bg-sky-500/15 rounded-full blur-3xl" />
        <div className="relative max-w-6xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-12">
          <p className="text-emerald-400 text-xs font-bold uppercase tracking-[0.25em] mb-4" style={{ animation: 'fadeInUp .5s ease both' }}>{s.subtitle || 'POS · Muhasebe · Yönetim'}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] max-w-3xl" style={{ animation: 'fadeInUp .6s ease 80ms both' }} data-testid="landing-hero-title">
            {landing.hero_title || 'İşletmenizi tek platformdan yönetin'}
          </h1>
          <p className="text-slate-400 text-base sm:text-lg mt-5 max-w-2xl leading-relaxed" style={{ animation: 'fadeInUp .6s ease 160ms both' }} data-testid="landing-hero-subtitle">
            {landing.hero_subtitle}
          </p>
          <div className="flex flex-wrap gap-3 mt-8" style={{ animation: 'fadeInUp .6s ease 240ms both' }}>
            <Link to="/kayit" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-500 hover:bg-emerald-600 font-semibold shadow-lg shadow-emerald-500/30 transition-colors" data-testid="landing-hero-register-btn">
              Hemen Başlayın <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/giris" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/15 hover:bg-white/5 font-medium transition-colors" data-testid="landing-hero-login-btn">
              <LogIn className="h-4 w-4" /> Giriş Yap
            </Link>
          </div>
          {byPlace('slider').length > 0 && <div className="mt-12"><AdSlider ads={byPlace('slider')} /></div>}
        </div>
      </section>

      <ModulesGrid />
      {byPlace('middle').length > 0 && <div className="max-w-6xl mx-auto px-5 sm:px-8 pb-8"><AdCards ads={byPlace('middle')} testId="ad-middle" /></div>}
      <ContactSection contact={contact} />
      {byPlace('bottom').length > 0 && <div className="max-w-6xl mx-auto px-5 sm:px-8 pb-12"><AdCards ads={byPlace('bottom')} testId="ad-bottom" /></div>}

      <footer className="border-t border-white/5 py-8 text-center text-xs text-slate-500" data-testid="landing-footer">
        {s.footer_text || `${title} © ${new Date().getFullYear()}`}
      </footer>
      <WhatsAppFab number={contact.whatsapp} />
    </div>
  );
}
